import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';
export interface FundDetailsDialogBottomBarStyleProps {
  fullWidth?: boolean;
  isMobileAppKeyboardVisible: boolean;
}

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    position: 'fixed',
    zIndex: 1,
    top: 'auto',
    bottom: 0,
    left: ({ fullWidth }: FundDetailsDialogBottomBarStyleProps) => fullWidth ? '0' : `calc(${theme.space.navWidth}px - 8px)`,
    width: '100%',
    padding: '24px 0',
    background: theme.color.greys[0],
    borderTop: `1px solid ${theme.color.greys[15]}`,
    '& > div': {
      padding: 0,
    },
    [theme.breakpoints.down('md')]: {
      left: ({ fullWidth }: FundDetailsDialogBottomBarStyleProps) => fullWidth ? 0 : theme.space.navCollapseWidth,
    },
    [theme.breakpoints.down('sm')]: {
      '& > div': {
        minHeight: 40,
      },
      left: () => 0,
      paddingTop: '16px',
      paddingRight: '0',
      paddingLeft: '0',
      paddingBottom: ({ fullWidth, isMobileAppKeyboardVisible }: FundDetailsDialogBottomBarStyleProps) => fullWidth || isMobileAppKeyboardVisible ? '0' : `${theme.space.mobileNavHeight()}px`,
    },
  },
  container: {
    width: ({ fullWidth }: FundDetailsDialogBottomBarStyleProps) => fullWidth ? '100%' : `calc(100% - ${theme.space.navWidth}px)`,
    [theme.breakpoints.down('md')]: {
      width: ({ fullWidth }: FundDetailsDialogBottomBarStyleProps) => fullWidth ? '100%' : `calc(100% - ${theme.space.navCollapseWidth}px)`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 16px',
      width: () => '100%',
    },
  },
}), { name: 'FundDetailsDialogBottomBar', index: StylesIndexInjections.UI_MOLECULES });
